<template lang="pug">
  .container-navigation.mx-auto
    v-card.card-navigation-drawer(v-if='drawer')
      v-app-bar.nav-drawe-bar(app temporary)
        v-card.nav-card-close.elevation-0
          a.margin-drawer-icon-bar
            font-awesome-icon.icon-drawer(@click.stop='drawer = !drawer' :icon="['fas', 'times']")
        v-card#check-ul.nav-card-menu.mx-auto.elevation-0
          p.text-center.fast-animation.mb-5
            a.help-link.help-link-menu.bold-style(@click="navigate('#home')") Главная
          p.text-center.normal-animation.mb-5
            a.help-link.help-link-menu(@click="navigate('#specialists')") Команда и специалисты
          p.text-center.slowly-animation.mb-5
            a.help-link.help-link-menu(@click="navigate('#startWork')") Как мы работаем
          p.text-center.normal-animation.mb-5
            a.help-link.help-link-menu(@click="navigate('#registration')") Сформировать команду
          p.text-center.fast-sec.mb-5
            a.help-link.help-link-menu(@click="openBLSSoft()") Проектная разработка
    v-card.card-navigation.elevation-0(v-else)
      v-app-bar.bar-style.justify-space-between(app :elevation="$vuetify.breakpoint.smAndDown ? 0 : 3")
        v-app-bar.bar-style.justify-space-between.bar-max(app elevation=0)
          a.a-img-nav
            v-img.img-nav(
              src="@/assets/logo/logo_outstaff.svg"
              @click="$vuetify.goTo('#home')"
              contain
              )
          v-card.card-link.elevation-0.justify-space-between(
            v-if="$vuetify.breakpoint.width>maxSizeHelpLink"
            )
            a.help-link.margin-help.text-center(@click="$vuetify.goTo('#specialists', {offset:-50})") Команда и специалисты
            a.help-link.margin-help.text-center(@click="$vuetify.goTo('#startWork', {offset:-50})") Как мы работаем
            a.help-link.margin-help.text-center(@click="$vuetify.goTo('#registration', {offset:-50})") Сформировать команду
            a.help-link.text-center(@click="openBLSSoft()") Проектная разработка
          div.info-nav
            a.text-nav.font-style(href="tel:+79525378839") +7 952 537 88 39
            a.text-nav(href="mailto:sales@bls-soft.ru") sales@bls-soft.ru
          a.margin-icon-bar(v-if="$vuetify.breakpoint.width<=maxSizeHelpLink")
            font-awesome-icon.bar-icon(@click.stop='drawer = !drawer' :icon="['fas', 'bars']")
          a.a-img-nav
            v-img.telegram-nav(
              src="@/assets/logo/telegram.svg"
              @click="openBLSSoftTelegram()"
              contain
              )
</template>

<script>
export default {
  name: 'Navigation',
  data: () => ({
    drawer: false,
    maxSizeHelpLink: 1139
  }),
  methods: {
    navigate(link) {
      this.drawer = !this.drawer
      this.$vuetify.goTo(link, {offset:-10})
    },
    openBLSSoft() {
      window.open('https://bls-soft.ru/')
    },
    openBLSSoftTelegram() {
      window.open('https://t.me/warst')
    }
  }
}
</script>
<style lang="sass" scoped>
  @import "scss/variables.scss"
  @import "scss/colors.scss"

  @media(max-width: $xsOnly)
    .bar-style
      height: 65px !important

    .text-nav
      font-size: 12px
      line-height: 11px !important

    .font-style
      margin-bottom: 7px

    .margin-drawer-icon-bar
      margin-top: 5px

    .margin-icon-bar
      margin-top: -4px

    .info-nav
      margin-top: -1px

  @media(max-width: $smAndDown)
    .img-nav
      max-width: max(90px, 16%)
      margin-right: 10px !important
    
    .telegram-nav
      align-self: flex-start
      width: 100% !important
      margin-left: 30% !important
      cursor: pointer

  @media(min-width: $smOnlyStart) and (max-width: $smOnlyEnd)
    .margin-icon-bar
      margin-top: -3px

    .margin-drawer-icon-bar
      margin-top: 5px

    .text-nav
      font-size: 14px

    .font-style
      margin-bottom: 6px

    .img-nav
      margin-top: 1px

  @media(min-width: $smAndUp)
    .bar-style
      height: min(calc(40px + 4vw), 125px) !important

  @media(min-width: $mdOnlyStart) and (max-width: $mdOnlyEnd)
    .margin-icon-bar
      margin-top: -4px

    .margin-drawer-icon-bar
      margin-top: 4px

    .text-nav
      font-size: 16px

    .font-style
      margin-bottom: 8px

    .info-nav
      margin-top: -1px

    .telegram-nav
      align-self: flex-start
      width: 100% !important
      margin-left: 30% !important
      cursor: pointer

  @media(min-width: $mdAndUp)
    .img-nav
      max-width: min(calc(57px + 6vw), 163px)

    .help-link
      font-size: min(calc(12px + 0.2vw), 16px)

  @media(min-width: $lgOnlyStart) and (max-width: $lgOnlyEnd)
    .margin-icon-bar
      margin-top: -5px

    .margin-drawer-icon-bar
      margin-top: 6px

  @media(min-width: $lgOnlyStart) and (max-width: 1620px)
    .text-nav
      font-size: 17px

    .font-style
      margin-bottom: 7px

    .info-nav
      margin-top: -1px

  @media(max-width: 1620px)
    .text-nav
      line-height: 15px

  @media(min-width: 1621px)
    .font-style
      font-family: GothamProMedium !important

    .img-nav
      margin-top: 5px

    .info-nav
      margin-top: -1px

    .text-nav
      font-size: 18px

  @media(min-width: $lgAndUp)
    .card-link
      margin-left: 5%
      margin-right: 5%

    .card-navigation
      ::v-deep
        .v-toolbar__content
          margin-top: 13px !important

    .card-navigation-drawer
      ::v-deep
        .v-toolbar__content
          margin-top: 10px !important

  @media (min-width: $xl)
    .help-link
      font-size: 16px !important

  @media (min-width: $xxl)
    .bar-max
      max-width: $maxWidthContainer
      margin: auto

  .bold-style
    font-weight: bold

  .nav-drawe-bar
    width: 100% !important
    height: 100% !important
    display: grid !important
    padding: 0 12px
    ::v-deep
      .v-toolbar__content
        display: grid !important
        height: auto !important
    .nav-card-close
      display: flex
      justify-content: end
      justify-self: end
      align-self: start
      background-color: transparent
    .nav-card-menu
      display: grid
      max-width: 400px
      justify-self: center
      align-self: baseline
      background: $backgroundContainer

  .container-navigation
    background-color: $white

  .card-navigation
    display: flex
    ::v-deep
      .v-toolbar__content
        display: flex
        margin-left: $marginMax
        margin-right: $marginMaxM
        max-width: $maxWidthContent
        width: 100%
        padding: 0
        margin-top: 1%

  .card-navigation-drawer
    display: flex
    ::v-deep
      .v-toolbar__content
        display: flex
        margin-left: $marginMaxM
        margin-right: calc($marginMax + 2px)
        max-width: $maxWidthContent
        padding: 0
        margin-top: 1%

  .nav-menu
    animation: animate 350ms ease .6s forwards

  .slowly-animation
    animation: animate calc(1500ms) forwards

  .normal-animation
    animation: animate calc(1000ms) forwards

  .fast-sec
    animation: animate calc(500ms) forwards

  @keyframes animate
    0%
      opacity: 0
      transform: translateX(-15em)
    100%
      opacity: 1

  .a-img-nav
    align-self: start
    max-width: 40%

  .img-nav
    align-self: start
    ::v-deep
      .v-image__image
        background-position: left center !important

  .telegram-nav
    align-self: flex-start
    width: 3rem
    margin-left: 3rem
    cursor: pointer

  .sm-img
    margin-top: 4px
    max-width: max(90px, 16%)

  .normal-img
    width: min(calc(50px + 6vw), 200px)

  .bar-style
    display: flex !important
    background-color: $white  !important
    padding: 12px

  .info-nav
    display: flex
    flex-direction: column
    align-items: flex-end
    min-width: fit-content
    margin-left: auto
    align-self: start
    vertical-align: top
    .text-nav
      text-decoration: none
      color: $grey
      font-family: GothamProClassic
      &:hover
        color: $blueBasic

  .card-link
    background-color: transparent
    max-width: 1000px
    width: inherit
    align-self: start
    display: flex
    align-items: flex-end

  .help-link
    text-decoration: none
    font-family: GothamProClassic
    color: $black
    display: inline-block
    &:hover
      color: $blueBasic

  .help-link-menu
    font-size: 18px !important

  .bar-icon
    justify-content: center
    font-size: 35px
    color: $barIcon
    height: 35px
    width: 31px

  .icon-drawer
    font-size: 43px
    justify-content: center
    color: $barIcon

  .margin-icon-bar
    vertical-align: top
    margin-left: 5%
    align-self: start

  .margin-drawer-icon-bar
    margin-left: 5%
    align-self: start

  .margin-help
    margin-right: 3%


</style>
